<template>
  <common-card class="mt-3">
    <v-row style="padding: 15px 20px 0 20px;">
      <v-col cols="12" md="6"><h1>Scripts</h1></v-col>
      <v-col cols="12" md="6" class="text-right">
        <v-btn
          class="common-botton"
          dark
          @click="$router.push('/administacion/scripts/crear')"
        >
          <v-icon class="mr-2">mdi-plus</v-icon><span>Crear</span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px;"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px;">
          <h3 style="color:#42352E;">Búsqueda detallada</h3>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.campaniaIds"
                label="Campañas"
                :items="campanias"
                item-text="compania"
                item-value="id"
                multiple
                outlined
                dense
                color="primary"
                background-color="white"
                :menu-props="{ maxHeight: 320 }"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small color="primary" v-if="index === 0">
                    {{ item.compania }}
                  </v-chip>
                  <span v-else-if="index === 1" class="grey--text text-caption">
                    (+{{ filters.campaniaIds.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.estatus"
                label="Estatus"
                :items="estatusOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                color="primary"
                background-color="white"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filters.nombre"
                label="Nombre Script"
                outlined
                dense
                color="primary"
                background-color="white"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="filters.fechaCreacion"
                label="Fecha Creación"
                type="date"
                append-icon="mdi-calendar"
                outlined
                dense
                color="primary"
                background-color="white"
              />
            </v-col>
          </v-row>

          <v-row class="d-flex justify-end" style="padding: 0 40px;">
            <v-col cols="12" md="2">
              <v-btn
                dark
                block
                outlined
                color="#00a7e4"
                rounded
                @click="clearFilters"
                >Limpiar</v-btn
              >
            </v-col>
            <v-col cols="12" md="2" class="text-right">
              <v-btn class="common-botton" dark block @click="fetchList"
                ><span>Filtrar</span></v-btn
              >
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div style="padding: 0 40px;"><hr /></div>

    <!-- Resultados -->
    <v-row>
      <v-col cols="12" class="mb-10" style="padding: 40px;">
        <v-data-table
          class="elevation-0"
          :headers="headers"
          :items="hasSearched ? rows : []"
          :items-per-page="10"
          dense
          :no-data-text="
            hasSearched ? 'Sin datos' : 'Usa los filtros y presiona “Filtrar”'
          "
        >
          <template #top>
            <v-row style="padding: 15px;">
              <v-col cols="8"><h2>Resultados de la búsqueda</h2></v-col>
            </v-row>
          </template>

          <template #item.estatus="{ item }">
            <v-chip
              :color="item.estatus === 'ACTIVO' ? 'green' : 'grey'"
              dark
              small
            >
              {{ item.estatus }}
            </v-chip>
          </template>

          <template #item.ver="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="$router.push(`/administacion/scripts/${item.id}`)"
              >mdi-eye</v-icon
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { listScripts } from "@/services/scripts/scripts.service.js";
import { getCampaingsList } from "@/services/campaings/campaing.service.js";

export default {
  components: { CommonCard },
  data() {
    return {
      headers: [
        { text: "Id", value: "id", width: 70 },
        { text: "Script", value: "nombre" },
        { text: "Estatus", value: "estatus", width: 120 },
        { text: "Campaña", value: "campaniasShort", width: 220 },
        { text: "Fecha Creación", value: "creadoEn", width: 170 },
        { text: "Ver", value: "ver", sortable: false, width: 80 },
      ],
      rows: [],
      hasSearched: false,
      filters: {
        nombre: null,
        estatus: null,
        campaniaId: null,
        campaniaIds: [],
        fechaCreacion: null,
      },
      campanias: [],
      campaniasIndex: {},
      estatusOptions: [
        { text: "Activo", value: "ACTIVO" },
        { text: "Inactivo", value: "INACTIVO" },
      ],
    };
  },
  async mounted() {
    await this.fetchCampaigns();
  },
  methods: {
    async fetchCampaigns() {
      try {
        const res = await getCampaingsList({});
        const arr = Array.isArray(res?.campanias) ? res.campanias : [];

        this.campaniasIndex = arr.reduce((acc, c) => {
          acc[Number(c.id)] = c;
          return acc;
        }, {});

        const activos = arr.filter((c) => String(c.status) === "1");
        this.campanias = activos
          .map((c) => ({ id: Number(c.id), compania: c.medio || `#${c.id}` }))
          .sort((a, b) => a.compania.localeCompare(b.compania));
      } catch (e) {
        console.error("Error cargando campañas", e);
        this.campanias = [];
        this.campaniasIndex = {};
      }
    },
    async fetchList() {
      this.hasSearched = true;
      try {
        this.hasSearched = true;
        const params = { ...this.filters };

        if (params.fechaCreacion) {
          const d = params.fechaCreacion; // 'YYYY-MM-DD'
          params.desde = `${d} 00:00:00`;
          params.hasta = `${d} 23:59:59`;
          delete params.fechaCreacion;
        }

        if (Array.isArray(params.campaniaIds) && !params.campaniaIds.length) {
          delete params.campaniaIds;
        }

        const data = await listScripts(params);
        const raw = Array.isArray(data) ? data : (data && data.data) || [];

        this.rows = raw.map((r) => {
          const ids = Array.isArray(r.campaniaIds)
            ? r.campaniaIds.map(Number).filter(Number.isFinite)
            : r.campaniaId != null
            ? [Number(r.campaniaId)]
            : [];

          let nombres = [];
          if (ids.length) {
            nombres = ids.map(
              (id) => this.campaniasIndex[id]?.medio || `#${id}`
            );
          } else if (r.campaniaNombre) {
            nombres = String(r.campaniaNombre)
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }

          const full = nombres.join(", ");
          let short = "—";
          if (nombres.length === 1) short = nombres[0];
          else if (nombres.length >= 2)
            short =
              `${nombres[0]}, ${nombres[1]}` +
              (nombres.length > 2 ? ` (+${nombres.length - 2} más)` : "");

          return { ...r, campaniasFull: full, campaniasShort: short };
        });
      } catch (e) {
        console.error("Error listando scripts", e);
        this.rows = [];
      }
    },

    clearFilters() {
      this.filters = {
        nombre: null,
        estatus: null,
        campaniaIds: [],
        fechaCreacion: null,
      };
      this.rows = [];
      this.hasSearched = false;
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}
</style>
